/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ImageFileUpIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB+UlEQVR4nN2Vz0tVQRTHH6Yh5EKwok27RBC3rm8FQumdc84V5p0jKBdbvH9AIYjgtRTct+ofMAJBoXIV1CYXLVJxqxtF8AcoCoqUMu/Nfd433l++aOPA4f6YOd/P+TF3bql0qwYiPwbiT4rkCEgu0kwh70U+AOXJwuIKZT9LGGLWANSfZ3IBJnInym2F/Mfadg4gHxIviyLZ8DyvXSn9xFilUukA5M04QGvdVffjrUKQpgiR567NI8/F1yDyU+s342T+LhuA8tkLw0533gvDTkD+cpUlL5j3Wuu7BuJk8qolgCL+6kT7JrPuNyuRfEzcUSiLAOVnUU8KAUyTTWNHRsd6jSU1ueh3kpxBzXgn2qbmvqi4u40zACmG8ksRV4BkFkjOgeRUIb8e1vqRMXMPJCctAnhtaGj8XuTjI0/4xC9dLcSwuyjgr4nGih8D6P6k/r3Q+oFCXlbEP31/7H5uk63g7khQHtBa3wGU94okTBUnXrlqsKybUuUBzlUgz6O5arXaVkQ8E+IsmEpM0xEHlFXb+NV4n+z1d1O54oedH5QHSzlDkXyLxGsw6xsE4w8bWaEsNRyAeL7ALjommuipr5cPBmLE7XNj/9vslppOVwDdB8QHeRAfeTopo9QP7Novs3bm8GH6MSBnQPK2JcC/jP8PQP6hSL67E5cXtBXuW+3MugAAAABJRU5ErkJggg==)
 */
export const ImageFileUpIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M2 18a4 4 0 0 0 4 4h7.9c.11 0 .14-.18.04-.22-.36-.16-.8-.4-1.06-.66a2.99 2.99 0 0 1-.85-1.72c-.03-.22-.2-.4-.43-.4H5.81a.75.75 0 0 1-.59-1.22l1.86-2.32a1.5 1.5 0 0 1 2.34 0l.5.64 2.23-2.97a2 2 0 0 1 3.2 0l.55.73.98-.98a3 3 0 0 1 4.24 0l.2.2a.4.4 0 0 0 .68-.29V10.5a.5.5 0 0 0-.5-.5H19a5 5 0 0 1-5-5V2.5a.5.5 0 0 0-.5-.5H6a4 4 0 0 0-4 4v12Zm8.2-12.02c.23-.91-.88-1.55-1.55-.9a.93.93 0 0 1-1.3 0c-.67-.65-1.78-.01-1.55.9a.93.93 0 0 1-.65 1.12c-.9.26-.9 1.54 0 1.8.48.14.77.63.65 1.12-.23.91.88 1.55 1.55.9a.93.93 0 0 1 1.3 0c.67.65 1.78.01 1.55-.9a.93.93 0 0 1 .65-1.12c.9-.26.9-1.54 0-1.8a.93.93 0 0 1-.65-1.12Z"
        clipRule="evenodd"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M21.66 8c.03 0 .05-.03.04-.06a3 3 0 0 0-.58-.82l-4.24-4.24a3 3 0 0 0-.82-.58.04.04 0 0 0-.06.04V5a3 3 0 0 0 3 3h2.66ZM18.3 14.3a1 1 0 0 1 1.4 0l4 4a1 1 0 0 1-1.4 1.4L20 17.42V23a1 1 0 1 1-2 0v-5.59l-2.3 2.3a1 1 0 0 1-1.4-1.42l4-4Z"
        className={colorClass}
      />
    </svg>
  );
};
